// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Footer = require("../components/footers/Footer.bs.js");
var Header = require("../components/headers/Header.bs.js");
var Loader = require("../uikit/reason/atoms/Loader/Loader.bs.js");
var TopNav = require("./TopNav.bs.js");
var Particles = require("../uikit/reason/Styles/Particles.bs.js");
var MediaQuery = require("../reason/common/Media/MediaQuery.bs.js");
var AuthSession = require("../utils/AuthSession.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var UseNewVersionNotice = require("../reason/newVersionNotice/UseNewVersionNotice.bs.js");
var SystemMessageDisplay = require("../reason/systemMessages/SystemMessageDisplay.bs.js");
var ClientAuthorizationCheck = require("../reason/common/ClientAuthorizationCheck/ClientAuthorizationCheck.bs.js");

function MainApp(props) {
  var match = React.useState(function () {
        return false;
      });
  var setTopNavIsOpened = match[1];
  var topNavIsOpened = match[0];
  UseNewVersionNotice.useNewVersionNotice();
  ClientAuthorizationCheck.use();
  var authSession = AuthSession.use();
  var mobileNavToggle = function (param) {
    setTopNavIsOpened(function (v) {
          return !v;
        });
  };
  var body = authSession !== undefined && authSession.__typename !== "AuthSessionInitializing" ? props.children : JsxRuntime.jsx(Loader.make, {
          flexGrow: true
        });
  var mobileNav = topNavIsOpened ? JsxRuntime.jsx(TopNav.make, {
          mobileNavToggle: mobileNavToggle
        }) : null;
  var tmp;
  if (authSession !== undefined) {
    switch (authSession.__typename) {
      case "AuthSession" :
      case "AuthSessionUnauthenticated" :
          tmp = true;
          break;
      case "AuthSessionInitializing" :
      case "__unselected" :
          tmp = false;
          break;
      
    }
  } else {
    tmp = false;
  }
  var tmp$1;
  if (authSession !== undefined && authSession.__typename === "AuthSession") {
    var tmp$2;
    tmp$2 = authSession.user.role === "AGENT" ? "agent" : "client";
    tmp$1 = tmp$2;
  } else {
    tmp$1 = undefined;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx(Header.make, {
                      isLoggedIn: tmp,
                      userRole: tmp$1,
                      handleSignout: (function () {
                          AuthSession.logout();
                        }),
                      mobileNavToggle: mobileNavToggle,
                      topNavIsOpened: topNavIsOpened
                    }),
                JsxRuntime.jsx(MediaQuery.make, {
                      query: {
                        TAG: "MinWidth",
                        _0: Particles.Breakpoint.ofString("545px")
                      },
                      children: JsxRuntime.jsx(TopNav.make, {
                            mobileNavToggle: mobileNavToggle
                          })
                    }),
                JsxRuntime.jsx(MediaQuery.make, {
                      query: {
                        TAG: "MaxWidth",
                        _0: Particles.Breakpoint.ofString("544px")
                      },
                      children: mobileNav
                    }),
                JsxRuntime.jsx(SystemMessageDisplay.make, {}),
                body,
                JsxRuntime.jsx(Footer.make, {})
              ],
              className: "min-h-screen bg-zinc-100 flex flex-col"
            });
}

var make = MainApp;

exports.make = make;
/* react Not a pure module */
